const strict = true;

const defaultState = function () {
  return {
    fePhoneNumber: "06.51.03.11",
    feEmailAddress: "info@fondoest.it",
    feDpoEmailAddress: "dpo@fondoest.it",
    feFaqWebSite: "https://www.fondoest.it/faq",
    feWebSiteLabel: "www.fondoest.it",
    usPhoneNumber: "051.41.85.748",
    usPhoneNumberForEstero: "051.63.89.046",
    usDpoEmailAddress: "privacy@unisalute.it",
    usFaqWebSite: "https://www.fondoest.it/faq",
    usWebSiteLabel: "www.fondoest.it",
    mhPhoneNumber: "848.694.670",
    mhPhoneNumberEstero: "+39 0461.1788999",
    mhWebSite: "https://www.mutualhelp.eu",
    mhWebSiteLabel: "www.mutualhelp.eu",
    mhFaqWebSite: "https://mutualhelp.fondoest.it/?lang=it",
    mhFaqWebSiteLabel: "mutualhelp.fondoest.it"
  };
};

const state = defaultState();

const getters = {
  getFePhoneNumber: state => state.fePhoneNumber,
  getFeEmailAddress: state => state.feEmailAddress,
  getFeDpoEmailAddress: state => state.feDpoEmailAddress,
  getFeFaqWebSite: state => state.feFaqWebSite,
  getFeWebSiteLabel: state => state.feWebSiteLabel,
  getUsPhoneNumber: state => state.usPhoneNumber,
  getUsPhoneNumberForEstero: state => state.usPhoneNumberForEstero,
  getUsDpoEmailAddress: state => state.usDpoEmailAddress,
  getUsFaqWebSite: state => state.usFaqWebSite,
  getUsWebSiteLabel: state => state.usWebSiteLabel,
  getMhPhoneNumber: state => state.mhPhoneNumber,
  getMhPhoneNumberEstero: state => state.mhPhoneNumberEstero,
  getMhWebSite: state => state.mhWebSite,
  getMhWebSiteLabel: state => state.mhWebSiteLabel,
  getMhFaqWebSite: state => state.mhFaqWebSite,
  getMhFaqWebSiteLabel: state => state.mhFaqWebSiteLabel
};

const mutations = {
  reset(state) {
    const s = defaultState();
    Object.keys(s).forEach(key => {
      state[key] = s[key];
    });
  }
};

const actions = {};

export default {
  namespaced: true,
  strict,
  state,
  getters,
  mutations,
  actions
};
